export default "__VITE_ASSET__a54e883a__"